import React, { useState } from 'react';
import { Loader2, Mail, AlertCircle } from 'lucide-react';
import { Button } from '../components/ui/Button';
import { getLink } from '../config/links';

export const LoginPage: React.FC = () => {
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setLoading(true);
    setError(null);
    
    const formData = new FormData(e.currentTarget);
    const email = formData.get('email');

    try {
      // Usamos o mesmo endpoint de waitlist para capturar o interesse no login
      const response = await fetch('/api/waitlist', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, name: 'Login Attempt', role: 'Acesso Direto' }),
      });

      if (!response.ok) throw new Error('Erro ao verificar acesso.');

      setSent(true);
    } catch (err: any) {
      setError('Ocorreu um problema ao verificar seu e-mail.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex flex-col justify-center py-12 px-4 sm:px-6 lg:px-8 bg-slate-50">
      <div className="sm:mx-auto sm:w-full sm:max-w-md">
        <h2 className="mt-6 text-center text-3xl font-display font-bold text-slate-900">
          Acesso em liberação
        </h2>
        <p className="mt-2 text-center text-sm text-slate-600">
          O PERO Brief está em fase beta restrita.
        </p>
      </div>

      <div className="mt-8 sm:mx-auto sm:w-full sm:max-w-md">
        <div className="bg-white py-8 px-4 shadow-sm border border-slate-200 sm:rounded-2xl sm:px-10">
          
          {error && (
            <div className="mb-4 p-3 bg-red-50 border border-red-100 text-red-600 text-sm rounded-lg flex items-center gap-2">
              <AlertCircle size={16} />
              {error}
            </div>
          )}

          {!sent ? (
            <form className="space-y-6" onSubmit={handleSubmit}>
              <div>
                <label htmlFor="email" className="block text-sm font-medium text-slate-700">
                  E-mail
                </label>
                <div className="mt-1">
                  <input
                    id="email"
                    name="email"
                    type="email"
                    autoComplete="email"
                    required
                    placeholder="voce@empresa.com"
                    className="appearance-none block w-full px-3 py-2 border border-slate-300 rounded-lg shadow-sm placeholder-slate-400 focus:outline-none focus:ring-primary focus:border-primary sm:text-sm"
                  />
                </div>
              </div>

              <div>
                <button
                  type="submit"
                  disabled={loading}
                  className="w-full flex justify-center py-2.5 px-4 border border-transparent rounded-lg shadow-sm text-sm font-medium text-white bg-slate-900 hover:bg-slate-800 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-slate-900 disabled:opacity-70 transition-colors"
                >
                  {loading ? <Loader2 className="animate-spin" size={20} /> : 'Solicitar link de acesso'}
                </button>
              </div>
            </form>
          ) : (
             <div className="text-center py-4 animate-in fade-in duration-500">
                <div className="mx-auto w-12 h-12 bg-blue-50 text-blue-600 rounded-full flex items-center justify-center mb-4">
                  <Mail size={24} />
                </div>
                <h3 className="text-lg font-medium text-slate-900 mb-2">Solicitação Recebida</h3>
                <p className="text-sm text-slate-500 mb-6">
                  Se seu acesso estiver ativo ou assim que for liberado, você receberá um link de login no seu e-mail.
                </p>
                <button onClick={() => setSent(false)} className="text-sm text-primary font-medium hover:underline">
                  Tentar outro e-mail
                </button>
             </div>
          )}

          <div className="mt-6">
            <div className="relative">
              <div className="absolute inset-0 flex items-center">
                <div className="w-full border-t border-slate-200" />
              </div>
              <div className="relative flex justify-center text-sm">
                <span className="px-2 bg-white text-slate-500">
                  Ainda não tem convite?
                </span>
              </div>
            </div>

            <div className="mt-6 grid grid-cols-1">
              <Button href={getLink('signup')} variant="outline" className="w-full">
                Entrar na lista de espera
              </Button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};